<div class="div-container"
     [ngClass]="{'invalid': this.field.formControl?.touched && to.required && count === 0}">

  <p *ngIf="this.to.required == false" class="optional-field">
    (Optional)
  </p>

  <ds-table disable-click fixed *ngIf="this.dataSourceY.length > 0 && this.dataSourceX.length > 0">
    <ds-table-header>
      <ds-table-row>
        <ds-table-header-col>{{ this.to.labelY }}</ds-table-header-col>
        <ds-table-header-col class="all" *ngIf="this.dataSourceX.length > 1">All</ds-table-header-col>
        <ds-table-header-col
          title="{{ x.value.description }}"
          *ngFor="let x of this.dataSourceX"
          column-key="{{ x.key }}"
          class="justify-content-center"
        >{{ x.value.name }}</ds-table-header-col
        >
      </ds-table-row>
    </ds-table-header>
    <ds-table-body>
      <ds-table-row *ngFor="let y of this.dataSourceY">

        <ds-table-cell class="d-flex flex-column align-items-start" style="white-space: normal"
                       column-key="{{ y.key }}">
          <p class="font-weight-bold">{{y.value.name}}</p>
          <p *ngIf="y.value.description"
             class="small">
            {{removePossibleHtmlTags(y.value.description)}}
          </p>
        </ds-table-cell>

        <ds-table-cell
          *ngIf="this.dataSourceX.length > 1"
          column-key="all"
          class="justify-content-center
                 ng-star-inserted
                 sc-ds-table-cell-h
                 sc-ds-table-cell-s
                 c-table--row-cell hydrated all"
        >
          <p class="small">
            <ds-checkbox
              name="check-all"
              value="check-all"
              (dsCheckboxChange)="onCheckboxAllRowChange(y.key,$event)">
            </ds-checkbox>
          </p>
        </ds-table-cell>

        <ds-table-cell
          *ngFor="let x of this.dataSourceX"
          column-key="{{ x.key }}"
          class="justify-content-center"
        >
          <p class="small">
            <ds-checkbox
              name="{{ x.value.name }}"
              value="{{ y.key }}|{{ x.key }}"
              [checked]="values | filterMatrix: y.key : x.key : reload"
              (dsCheckboxChange)="onCheckboxChange(y.key, x.key, $event)"
            ></ds-checkbox>
          </p
          >
        </ds-table-cell>
      </ds-table-row>
    </ds-table-body>
  </ds-table>
</div>










